const POSITION_OFFSET = 0.00006;
const POSITION_COORDINATE_DECIMAL_PLACES = 6;
function addPositionOffset(position: { latitude: number | undefined; longitude: number | undefined }) {
    position.latitude = position.latitude ?? 0;
    position.longitude = position.longitude ?? 0;

    position.latitude += POSITION_OFFSET;
    position.longitude += POSITION_OFFSET;

    position.latitude = parseFloat(position.latitude.toFixed(POSITION_COORDINATE_DECIMAL_PLACES));
    position.longitude = parseFloat(position.longitude.toFixed(POSITION_COORDINATE_DECIMAL_PLACES));
}

export default {
    addPositionOffset
};
